import React from "react";
import { Box, Heading, Text, Button } from "@chakra-ui/react";
import Section from "./Section";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";

const DelAccount: React.FC = () => {
  const { t } = useTranslation();

  const handleContact = () => {
    window.location.href = "mailto:marketing@deepsoulai.com";
  };

  return (
    <>
      <SEO 
        title={t("seo.pages.deleteAccount.title")}
        description={t("seo.pages.deleteAccount.description")}
        keywords={t("seo.pages.deleteAccount.keywords")}
        canonical="https://deepsoulai.com/delAccount"
        noindex={true}
      />
      <Section title={t("delAccount.title")}>
      <Box textAlign="center" p={6}>
        <Heading size="lg" mb={4}>
          {t("delAccount.msg1")}
        </Heading>
        <Text fontSize="md" mb={4}>
          {t("delAccount.msg2")}
          <strong> marketing@deepsoulai.com </strong>
          {t("delAccount.msg3")}
        </Text>
        <Button colorScheme="red" onClick={handleContact}>
          {t("delAccount.msg4")}
        </Button>
      </Box>
    </Section>
    </>
  );
};

export default DelAccount;
